import { rankingData } from '@/mocks/homeData';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-accent-500',
  down: 'ri-arrow-down-line text-foreground-400',
  same: 'ri-subtract-line text-foreground-400',
};

const rankColors: Record<number, string> = {
  1: 'bg-accent-500 text-background-50',
  2: 'bg-primary-500 text-background-50',
  3: 'bg-secondary-500 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center">
            热度榜单
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            本周最受关注的影视作品排行
          </p>
          <div className="mt-8 bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
            {rankingData.map((item, idx) => (
              <div
                key={item.id}
                className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors ${
                  idx < rankingData.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold font-label flex-shrink-0 ${
                    rankColors[item.rank] || 'bg-background-100 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 font-heading truncate">
                    {item.title}
                  </div>
                  <div className="text-xs text-foreground-400 mt-0.5">{item.type}</div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className="text-sm font-bold text-accent-600 font-label">{item.score}</span>
                  <span className="text-xs text-foreground-400 hidden sm:inline">{item.hot}</span>
                  <span className={`w-5 h-5 flex items-center justify-center ${trendIcon[item.trend]}`}>
                    <i className={trendIcon[item.trend]}></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}